import React, { useEffect, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import SearchModal from './components/SearchModal';
import { SearchProvider, useSearchModal } from './contexts/SearchContext';
import HomePage from './pages/HomePage';
import About from './pages/About';
import Portfolio from './pages/Portfolio';
import Contact from './pages/Contact';
import Immigration from './pages/Immigration';
import CyberSecurity from './pages/CyberSecurity';
import CorporateServices from './pages/CorporateServices';
import Biotech from './pages/Biotech';
import Education from './pages/Education';
import SoftwareDevelopment from './pages/SoftwareDevelopment';
import IntrusionDetection from './pages/IntrusionDetection';
import NewsArticles from './pages/NewsArticles';
import Events from './pages/Events';
import Videos from './pages/Videos';
import MRKArtGallery from './pages/MRKArtGallery';
import BlockchainSeedInvestment from './pages/BlockchainSeedInvestment';
import Event from './pages/Event';
// Lazy-load the media coverage hub — it imports a 640 KB JSON register
// that would otherwise be inlined into the main bundle for every route.
const GlobalMediaCoverage = React.lazy(() => import('./pages/GlobalMediaCoverage'));
import './App.css';
import { initLineAnimations } from './utils/lineAnimations';
import './utils/lineAnimations.css';

// Component to handle search modal inside the context
const AppSearchModal = () => {
  const { isOpen, closeModal } = useSearchModal();
  return <SearchModal isOpen={isOpen} onClose={closeModal} />;
};

function App() {
  useEffect(() => {
    // Initialize line animations after component mount
    const timer = setTimeout(() => {
      const observer = initLineAnimations();
      
      return () => {
        if (observer) observer.disconnect();
      };
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  return (
    <SearchProvider>
      <Router>
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/portfolio/immigration" element={<Immigration />} />
            <Route path="/portfolio/cybersecurity" element={<CyberSecurity />} />
            <Route path="/portfolio/corporate-services" element={<CorporateServices />} />
            <Route path="/portfolio/biotech" element={<Biotech />} />
            <Route path="/portfolio/education" element={<Education />} />
            <Route path="/portfolio/software-development" element={<SoftwareDevelopment />} />
            <Route path="/portfolio/intrusion-detection" element={<IntrusionDetection />} />
            <Route path="/media/news" element={<NewsArticles />} />
            <Route path="/media/events" element={<Events />} />
            <Route path="/media/videos" element={<Videos />} />
            <Route path="/mrk-art-gallery" element={<MRKArtGallery />} />
            <Route path="/portfolio/art" element={<MRKArtGallery />} />
            <Route path="/portfolio/blockchain-seed-investment" element={<BlockchainSeedInvestment />} />
            <Route path="/portfolio/business-financial-advisory" element={<Event />} />
            <Route path="/portfolio/event" element={<Event />} />
            <Route path="/contact" element={<Contact />} />
            <Route
              path="/global-media-coverage"
              element={
                <Suspense fallback={null}>
                  <GlobalMediaCoverage />
                </Suspense>
              }
            />
          </Routes>
          <Footer />
          <AppSearchModal />
        </div>
      </Router>
    </SearchProvider>
  );
}

export default App;